import React, { useState } from 'react';
import Layout from 'layouts/manager/Layout';
import MemberForm from './Form';
import ContractSection from './ContractSection';
import BillingSection from './BillingSection';
import VendorSection from './VendorSection';

const PREFS = [
  '東京都', '大阪府', '愛知県', '北海道', '福岡県', 'その他'
];
const CONTRACT_PLANS = [
  { value: 'basic', label: 'ベーシック' },
  { value: 'premium', label: 'プレミアム' },
  { value: 'custom', label: 'カスタム' },
];
const CONTRACT_PAYMENT_METHODS = [
  { value: 'bank', label: '銀行振込' },
  { value: 'credit', label: 'クレジットカード' },
  { value: 'paid', label: 'Paid' },
  { value: 'other', label: 'その他' },
];
const CONTRACT_STATUSES = [
  { value: 'active', label: '有効' },
  { value: 'inactive', label: '無効' },
  { value: 'cancelled', label: '解約' },
];
const CALL_GROUPS = [
  { value: 'group1', label: 'グループ1' },
  { value: 'group2', label: 'グループ2' },
  { value: 'group3', label: 'グループ3' },
];
const RESCUE_MENUS = [
  { value: 'water', label: '水まわり' },
  { value: 'light', label: '電気' },
  { value: 'pest', label: '害虫' },
  { value: 'subscription', label: '定額レスキュー' },
  { value: 'human', label: '人材' },
];

const Edit: React.FC = () => {
  const [form, setForm] = useState({
    loginId: 'sample_id',
    password: '',
    passwordConfirm: '',
    memberNo: '0001',
    manager: '',
    store: '',
    post1: '',
    post2: '',
    pref: '',
    city: '',
    address1: '',
    address2: '',
    tel: '',
    email: '',
    managerEmail: '',
    contractNo: '',
    otherPayments: {
      card: false,
      paid: false,
    },
    rescueRegister: '',
    paymentTerm: '',
    remarks: '',
    memo: '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [openContract, setOpenContract] = useState(false);
  const [openBilling, setOpenBilling] = useState(false);
  const [openVendor, setOpenVendor] = useState(false);
  const [openMain, setOpenMain] = useState(true);
  const [contracts, setContracts] = useState([
    {
      plan: '',
      fee: '',
      appliedAt: '',
      startedAt: '',
      renewedAt: '',
      paymentMethod: '',
      usageCount: '',
      annualUsageCount: '',
      status: 'active',
      agencyNo: '',
      agencyName: '',
    },
  ]);
  const [billingForm, setBillingForm] = useState({
    company: '',
    manager: '',
    post1: '',
    post2: '',
    pref: '',
    city: '',
    address1: '',
    address2: '',
    tel: '',
    logo: null as File | null,
  });
  const [vendors, setVendors] = useState([
    {
      name: '',
      email: '',
      callGroup: '',
      rescueMenus: [] as string[],
    },
  ]);
  const logoInputRef = React.useRef<HTMLInputElement | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    if (type === 'checkbox' && name.startsWith('otherPayments.')) {
      const key = name.replace('otherPayments.', '');
      setForm((prev) => ({
        ...prev,
        otherPayments: {
          ...prev.otherPayments,
          [key]: (e.target as HTMLInputElement).checked,
        },
      }));
    } else if (type === 'radio' && name === 'rescueRegister') {
      setForm((prev) => ({ ...prev, rescueRegister: value }));
    } else if (type === 'checkbox') {
      setForm((prev) => ({ ...prev, [name]: (e.target as HTMLInputElement).checked }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  return (
    <Layout>
      <div className="flex items-center justify-between mx-auto mb-8">
        <h1 className="text-2xl font-bold text-gray-800">店舗管理</h1>
      </div>
      <div className="p-8 mx-auto bg-white border border-gray-200 rounded-lg shadow-md">
        <div className="mb-3">
          <a href="/manager/member" className="text-sm text-gray-500 underline transition hover:text-gray-700">&lt; 一覧画面に戻る</a>
        </div>
        {/* 店舗情報編集セクション タイトル */}
        <div className="mb-6">
          <button type="button" className={`flex items-center justify-between w-full pt-1 pb-2 text-left text-lg font-bold text-gray-800 border-b border-gray-200 focus:outline-none`} onClick={() => setOpenMain((v) => !v)}>
            <span>店舗情報編集</span>
            <span className="text-base">{openMain ? '▲' : '▼'}</span>
          </button>
        </div>
        <form>
        {openMain && (
          <MemberForm
            form={form}
            setForm={setForm}
            showPassword={showPassword}
            setShowPassword={setShowPassword}
            showPasswordConfirm={showPasswordConfirm}
            setShowPasswordConfirm={setShowPasswordConfirm}
            handleChange={handleChange}
          />
        )}
          <div className="mt-10 space-y-6">
            {/* 契約情報セクション 共通化 */}
            <ContractSection
              open={openContract}
              setOpen={setOpenContract}
              contracts={contracts}
              setContracts={setContracts}
              CONTRACT_PLANS={CONTRACT_PLANS}
              CONTRACT_PAYMENT_METHODS={CONTRACT_PAYMENT_METHODS}
              CONTRACT_STATUSES={CONTRACT_STATUSES}
            />
            {/* 請求情報セクション 共通化 */}
            <BillingSection
              open={openBilling}
              setOpen={setOpenBilling}
              billingForm={billingForm}
              setBillingForm={setBillingForm}
              PREFS={PREFS}
              logoInputRef={logoInputRef}
            />
            {/* 既存お取引業者登録セクション 共通化 */}
            <VendorSection
              open={openVendor}
              setOpen={setOpenVendor}
              vendors={vendors}
              setVendors={setVendors}
              CALL_GROUPS={CALL_GROUPS}
              RESCUE_MENUS={RESCUE_MENUS}
            />
          </div>
        </form>
        <div className="flex items-center justify-between gap-4 mt-8">
          <a href="/manager/member" className="text-sm text-gray-500 underline transition hover:text-gray-700">&lt; 一覧画面に戻る</a>
          <button type="submit" form="" className="px-6 py-2 min-w-[120px] font-semibold text-white rounded bg-primary hover:bg-[#001b40] transition text-sm shadow">保存</button>
        </div>
      </div>
    </Layout>
  );
};

export default Edit;
